import React from "react";
import Topnav from "components/TopNav/Topnav";
import { useSelector } from "react-redux";

import { useLocation } from "react-router-dom";

const Layout = () => {
  const userToken = useSelector((state) => state.user.userToken);

  // Once Authentication enabled, will do this
  // return <>{userToken && <Topnav />}</>;
  return <Topnav />
};

export default Layout;
